/* Gassas note profile page (assets/gassas-note-page.js).
   Draws the perfumes that carry this note, grouped by top / heart / base, from the shared feed.
   v3: the "show all" button goes to the store search for the note, because v3 has no finder filters. */
(function () {
  'use strict';
  var G = window.GassasNotes;
  var F = window.GassasFeed;
  if (!G || !F) return;
  var root = document.querySelector('[data-np-root]');
  var host = root && root.querySelector('[data-np-lists]');
  if (!root || !host) return;

  var id = root.getAttribute('data-note-id');
  var name = root.getAttribute('data-note-name') || id;
  var lang = F.lang;
  var htmlLang = String(document.documentElement.lang || '').slice(0, 2).toLowerCase();
  if (htmlLang === 'da') lang = 'da';
  if (htmlLang === 'nb' || htmlLang === 'no' || htmlLang === 'nn') lang = 'nb';
  var LIMIT = 8;
  var TXT = {
    sv: {
      head: { top: ' i toppen', heart: ' i hjärtat', base: ' i basen' },
      one: ' parfym', many: ' parfymer',
      all: 'Visa alla dofter med den här noten',
      none: 'Ingen parfym i butiken har den här noten än.',
      error: 'Parfymerna kunde inte laddas just nu.'
    },
    da: {
      head: { top: ' i toppen', heart: ' i hjertet', base: ' i basen' },
      one: ' parfume', many: ' parfumer',
      all: 'Se alle dufte med denne note',
      none: 'Ingen parfume i butikken har denne note endnu.',
      error: 'Parfumerne kunne ikke indlæses lige nu.'
    },
    nb: {
      head: { top: ' i toppen', heart: ' i hjertet', base: ' i basen' },
      one: ' parfyme', many: ' parfymer',
      all: 'Se alle dufter med denne noten',
      none: 'Ingen parfyme i butikken har denne noten ennå.',
      error: 'Parfymene kunne ikke lastes inn akkurat nå.'
    },
    en: {
      head: { top: ' in the top', heart: ' in the heart', base: ' in the base' },
      one: ' fragrance', many: ' fragrances',
      all: 'Show all fragrances with this note',
      none: 'No fragrance in the store has this note yet.',
      error: 'The fragrances could not be loaded right now.'
    }
  };
  var T = TXT[lang];
  var TIERS = ['top', 'heart', 'base'];

  function build(products) {
    var html = '';
    var total = 0;
    var anyMore = false;
    TIERS.forEach(function (tier) {
      var list = products.filter(function (p) { return p.tiers[tier][id]; });
      if (!list.length) return;
      total += list.length;
      if (list.length > LIMIT) anyMore = true;
      list.sort(function (a, b) { return (b.r - a.r) || (a.idx - b.idx); });
      var cards = list.slice(0, LIMIT).map(function (p) { return F.card(p); }).join('');
      html += "<section class='np-block'><h2 class='np-block__title'>" + F.esc(name + T.head[tier]) +
        " <span class='np-block__count'>" + list.length + (list.length === 1 ? T.one : T.many) + "</span></h2>" +
        "<ul class='df-grid'>" + cards + '</ul></section>';
    });
    if (anyMore) {
      html += "<p><a class='df-btn' href='" + F.esc(G.root() + 'search?type=product&q=' + encodeURIComponent(name)) + "'>" + F.esc(T.all) + '</a></p>';
    }
    host.innerHTML = total ? html : "<p class='np-empty'>" + F.esc(T.none) + '</p>';
  }

  F.load().then(function (products) {
    products.forEach(function (p, i) { p.idx = i; });
    build(products);
  }).catch(function () {
    host.innerHTML = "<p class='np-empty'>" + F.esc(T.error) + '</p>';
  });
})();